import { isArray, map } from 'lodash';
export const reduceReducers = (...reducers) => (state, action) =>
  reducers.reduce((acc, nextReducer) => nextReducer(acc, action), state);

export const getErrors = (error) => (isArray(error)
  && map(error, (item) => {
    if (item?.field) {
      if (item?.field?.toLowerCase() !== 'uuid' || item?.field?.toLowerCase() !== 'applicationuuid ') {
        return `${item.field} : ${item.error}`;
      }
    }
    return `${item.error}`;
  })) || [];
